module.exports = "/_next/static/images/gf-f689ce443bf2c745bf8ce4f5e8785e14.svg";